import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonComp } from 'atoms/Buttons';
import _ from 'lodash';
import CustomizationAccordionComp from '../CustomizationAccordion/Container/CustomizationAccordionComp';
import {
  isEmptyObject,
  getItemQuantity,
  getItemQuantityByFoodLineId,
  getItemValueElseNA,
  getPriceWithExtractingJsonHelper,
  getUserType,
  getCouponDetails,
} from 'common/utilities/utils';
import { setAnalyticsDataOnConfirm } from '../ProductListingModalOptionsUtilities/ProductListingModalOptionsUtils';
import {
  addItemToCartAction,
  setUserLastActiveTime,
  updateLineitemAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import PRODUCT_CONSTANTS from '../Constants/ProductListingModalOptionsConstants';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { CART_PAGE_CONSTANTS } from '../../CartPage/Constants/CartPageConstants';
import MENU_CONSTANT from 'organisms/GenericMenuCategories/MenuConstants/MenuConstants';
import { QuantityModifier } from 'molecules/QuantityModifier';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { addFavouriteItemToCart } from 'organisms/AccountPage/accountPageUtils';
import { ANALYTICS_SHARED_CONSTANTS } from 'common/constants/SharedConstants';
import { logAddToCartEvent } from 'organisms/MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { getFoodlineItemIndex } from 'organisms/CartPage/Utils/cartPageUtils';

/**
 * Product List Form
 * @param {*} props - Object
 */
export const keyDownUpArrows = e => {
  let focusModal = document.querySelector('.product-listing-component form .accordion-test');
  if (e.key === 'ArrowDown' && typeof focusModal != undefined && focusModal != null) {
    focusModal.focus();
  }
};

export const clickConfirm = (event, modalClickParams) => {
  const {
    setClickEvent,
    setConfirmed,
    productMapById,
    modifiersList,
    data,
    currencyConversionFactor,
    itemCount,
    minipdpData,
    FROMFLAGEDIT,
    dispatch,
    cartReducer,
    tenantId,
    id,
    modifierGrp,
    userOrderStateDispatch,
    confirmUpsizeName,
    userType,
    categoryMapById,
  } = modalClickParams;
  const { foodLines } = cartReducer?.cartData || {};
  const { couponCode, discountTotal } = getCouponDetails(cartReducer?.cartData);
  const getCartFoodItem = isEmptyObject(cartReducer?.cartData)
    ? getItemQuantityByFoodLineId(minipdpData?.foodLineId, cartReducer?.cartData)
    : {};
  const quantityUpdate = Math.abs(itemCount - getCartFoodItem?.count);
  let itemVariantsList = '';
  event.stopPropagation();
  event.preventDefault();
  setClickEvent(event);
  setConfirmed(true);
  // To set analytics data when event triggered for add to cart from favourite menu
  const itemId = id?.split('_')[0] || '';
  const { categoryId: productCatId = '' } = productMapById?.[itemId] ?? {};
  const { id: catId = '', name: catName = '', url: catUrl = '' } = categoryMapById?.[productCatId] ?? {};
  _.forEach(modifiersList, value => {
    itemVariantsList += `${value[0].name}, `;
  });
  const priceWithOutTax = getPriceWithExtractingJsonHelper(
    data?.availability[0],
    data?.additionalProperties,
    currencyConversionFactor,
  );
  let itemObj = {
    item_name: getItemValueElseNA(data?.name),
    item_id: getItemValueElseNA(data?.id),
    item_category: catName,
    coupon: couponCode,
    discount: +(discountTotal / currencyConversionFactor).toFixed(2),
    price: getItemValueElseNA(priceWithOutTax),
    item_list_name: catName,
    item_list_id: catId,
    index: getFoodlineItemIndex(foodLines, data?.id, 0),
    quantity: quantityUpdate,
    currency: ANALYTICS_SHARED_CONSTANTS.INR,
    item_variant: !data?.modgrps?.length ? 'NA' : data?.modgrps?.reduce((acc, cv) => acc + `${cv?.name}, `, ''),
  };
  if (minipdpData.fromFlag !== FROMFLAGEDIT) {
    dispatch(
      addItemToCartAction(
        {
          params: {
            basketId: cartReducer?.cartData?.id,
          },
          tenantId: tenantId,
        },
        [
          {
            Id: id,
            categoryId: catId,
            quantity: itemCount,
            modGrps: modifierGrp,
            categoryName: catName,
            categoryUrl: catUrl,
          },
        ],
      ),
    );
    addFavouriteItemToCart({
      item_name: getItemValueElseNA(data?.name),
      item_id: getItemValueElseNA(data?.id),
      item_category: catName,
      price: getItemValueElseNA(data?.availability?.[0]?.price / currencyConversionFactor),
      item_variant: getItemValueElseNA(itemVariantsList?.trim()),
      item_list_name: catName,
      item_list_id: catId,
      index: 1,
      quantity: itemCount,
      currency: ANALYTICS_SHARED_CONSTANTS.INR,
    });
  } else {
    dispatch(
      updateLineitemAction(
        {
          params: {
            basketId: cartReducer?.cartData?.id,
            basketLineItemId: minipdpData.foodLineId,
          },
          tenantId: tenantId,
        },
        { Id: id, quantity: itemCount, modGrps: modifierGrp },
      ),
    );
    const totalValue = itemObj?.price * itemObj?.quantity;
    logAddToCartEvent(userType, itemObj, +totalValue);
  }

  dispatch(setUserLastActiveTime(new Date()));
  userOrderStateDispatch({
    type: CART_PAGE_CONSTANTS.SET_ADDED_LOCATION,
    value: {
      itemLocation: { itemid: id, addedFrom: 'PLP-Model' },
    },
  });
  setAnalyticsDataOnConfirm(confirmUpsizeName);
};

const ProductListingModalForm = props => {
  const { data, categoryId, handleClose, showPriceContent = true, source = '' } = props;
  const { id, modgrps, availability = [], additionalProperties = [] } = data;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { confirmUpsizeName, minipdpData } = userOrderState;
  const [modifierGrp, setModifierGroup] = useState(modgrps);
  const [modifiersList, setModifiersList] = useState([]);
  const dispatch = useDispatch();
  const tenantReducer = useSelector(data => data.tenantReducer);
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {}, isAddItemLoading = false } = cartReducer || {};
  const {
    currencySymbol,
    tenantId,
    currencyConversionFactor,
    maxItemCountPerLineItem,
    componentOptions: { web: { global: { showPriceWithTax = false } = {} } = {} } = {},
  } = tenantReducer;
  const { flatResponse: { productMapById = {}, categoryMapById = {} } = {} } =
    useSelector(({ menuReducer }) => menuReducer) ?? {};
  const [modifiedItemPrice, setModifiedItemPrice] = useState(0);
  const itemPrice = getPriceWithExtractingJsonHelper(
    availability[0],
    additionalProperties,
    currencyConversionFactor,
    showPriceWithTax,
  );
  const { ADDTOCART, UPDATECART } = PRODUCT_CONSTANTS;
  const { FROMFLAGEDIT, EDIT_CLICKED } = START_ORDER_CONSTANTS;
  const [itemCount, setItemCount] = useState(1);
  const [cartItemCount, setCartItemCount] = useState(0);
  const { ITEM_QUANTITY } = MENU_CONSTANT;
  const [confirmed, setConfirmed] = useState(false);
  const [clickevent, setClickEvent] = useState(null);
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const userType = getUserType(userParams?.localized, userParams?.loggedIn);
  const modalClickParams = {
    setClickEvent,
    setConfirmed,
    categoryId,
    modifiersList,
    data,
    itemCount,
    minipdpData,
    FROMFLAGEDIT,
    dispatch,
    cartReducer,
    tenantId,
    id,
    modifierGrp,
    userOrderStateDispatch,
    confirmUpsizeName,
    productMapById,
    currencyConversionFactor,
    userType,
    categoryMapById,
  };

  const getSelectedModifiers = modArray => {
    let totalDeltaPrice = 0;
    let modGrps = [];
    modArray.forEach(element => {
      let obj = {};
      obj.id = element[0].modgrpId;
      obj.modifiers = [];
      element.forEach(modEle => {
        let modObj = {};
        let moditem = JSON.parse(JSON.stringify(modEle));
        modObj.id = moditem.id;
        modObj.quantity = moditem.defaultQuantity;
        modObj.modGrps = moditem.modgrps;
        modObj.categoryId = categoryId;
        obj.modifiers.push(modObj);
        let price = getPriceWithExtractingJsonHelper(
          modEle.availability[0],
          modEle.additionalProperties,
          currencyConversionFactor,
          showPriceWithTax,
        );
        totalDeltaPrice += price; /*adding delta price for selected modifiers*/
      });
      modGrps.push(obj);
    });
    setModifiedItemPrice(itemPrice + totalDeltaPrice);
    setModifierGroup(modGrps);
  };
  useEffect(() => {
    props.callBackToPDP?.({
      modifierGrp,
      modifiedItemPrice,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modifierGrp]);
  useEffect(() => {
    const getItem = isEmptyObject(cartData) ? getItemQuantity(id, cartData) : {};
    const getItemCount = isEmptyObject(getItem) ? getItem.count : 0;
    setCartItemCount(getItemCount);
    if (minipdpData.fromFlag === FROMFLAGEDIT) {
      const getFoodItem = isEmptyObject(cartData) ? getItemQuantityByFoodLineId(minipdpData.foodLineId, cartData) : {};
      const getFoodItemCount = isEmptyObject(getFoodItem) ? getFoodItem.count : 1;
      setItemCount(getFoodItemCount);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);
  useEffect(() => {
    return () => {
      userOrderStateDispatch({
        type: EDIT_CLICKED,
        value: { cartEditClicked: false },
      });
    };
  }, [userOrderStateDispatch, EDIT_CLICKED]);

  const updateItemQuantity = (e, flag) => {
    flag === CART_PAGE_CONSTANTS.QUANTITY_ACTION.Increase
      ? setItemCount(prevCount => prevCount + 1)
      : setItemCount(prevCount => prevCount - 1);
  };

  useEffect(() => {
    if (confirmed && !isAddItemLoading) {
      handleClose(clickevent);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmed, isAddItemLoading]);

  useEffect(() => {
    window.addEventListener('keydown', keyDownUpArrows);
    return () => {
      window.removeEventListener('keydown', keyDownUpArrows);
    };
  });

  const computePrice = price => {
    return (itemCount * price).toFixed(2);
  };

  const cartButtonText =
    minipdpData.fromFlag === FROMFLAGEDIT ? translateWithI18Next(UPDATECART) : translateWithI18Next(ADDTOCART);

  return (
    <React.Fragment>
      <div className='modal-body-row product-listing-component' data-testid='product-listing-component'>
        <form className='form'>
          {/* <a href="#" className="product-list-option" aria-hidden="true">Select your Option</a> */}
          {isEmptyObject(modgrps) ? (
            <CustomizationAccordionComp
              grouplist={modgrps}
              getSelectedModifiers={getSelectedModifiers}
              selectedModifiers={setModifiersList}
              source={source}
            />
          ) : null}
        </form>
      </div>
      {showPriceContent && (
        <div className='price-content'>
          <div className='price-content-parent' data-testid='product-listing-button-comp'>
            {itemCount ? (
              <QuantityModifier
                itemCount={itemCount}
                itemQuantity={ITEM_QUANTITY}
                updateItemQuantity={updateItemQuantity}
                quantityAction={CART_PAGE_CONSTANTS.QUANTITY_ACTION}
                item={undefined}
                maxItemCountPerLineItem={maxItemCountPerLineItem}
                cartItemCount={cartItemCount + 1}
              />
            ) : null}
            <ButtonComp
              className={`button start-order-btn ${isAddItemLoading ? 'blackButton' : 'redButton'} customizeCartButton`}
              id='startOrderItemButton'
              data-testid='product-listing-button'
              type='submit'
              name={'product-listing-button'}
              onClickHandler={e => clickConfirm(e, modalClickParams)}
            >
              <span className='title-for-button'>{`${cartButtonText}`}</span>
              <span className='currency-symbol'>{`${currencySymbol} ${computePrice(modifiedItemPrice)}`}</span>
            </ButtonComp>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ProductListingModalForm;
